export default __webpack_public_path__ + "static/media/logo-intelligaia.5cde485d.svg";